const options = {
  5: "bg-blue-200/5",
  10: "bg-blue-200/10",
  25: "bg-blue-200/25",
  50: "bg-blue-200/50",
  75: "bg-blue-200/75",
  90: "bg-blue-200/90",
  100: "bg-blue-200",
};

const from = {
  5: "from-blue-200/5",
  10: "from-blue-200/10",
  25: "from-blue-200/25",
  50: "from-blue-200/50",
  75: "from-blue-200/75",
  90: "from-blue-200/90",
  100: "from-blue-200",
};

export default function getBackgroundBlue200(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
